import axios, { getData } from 'lib/axios'

// connected modules (payroll settings)
export const getConnectedModules = async () => {
  return axios.get('admin/payroll/connected-modules').then(getData)
}

export const updateConnectedModules = async (data) => {
  return axios.post('admin/payroll/connected-modules', data).then(getData)
}

// "Add claims" modal on the adjust payroll page
export const getEmployeeClaims = async ({ time_id, employee_id }) => {
  return axios.get(`admin/payroll/${time_id}/employees/${employee_id}/claims`).then(getData)
}

export const saveEmployeeClaims = async ({ time_id, employee_id, claim_ids }) => {
  return axios
    .post(`admin/payroll/${time_id}/employees/${employee_id}/claims`, { claim_ids })
    .then(getData)
}
